import StoresAfterSalesControl from './StoresAfterSalesControl.js';
import worldMap from '../../core/map';

export class StoreInactiveAfterSalesControl extends StoresAfterSalesControl {
  constructor () {
    const options = {
      name: 'StoreInactiveAfterSales',
      context: 'LAYER_AFTER_SALES_NETWORK',
    };

    super(options);
  }

  static getInstance () {
    if (!StoreInactiveAfterSalesControl._instance) {
      StoreInactiveAfterSalesControl._instance = new StoreInactiveAfterSalesControl();
    }

    return StoreInactiveAfterSalesControl._instance;
  }
}

export default StoreInactiveAfterSalesControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/AfterSales/StoreInactiveAfterSalesControl.js